import {
  Content,
  ContentHeader,
  CreateButton,
  PageWithHeader,
  SupportButton,
  TableColumn,
  TableProps,
} from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { CatalogKindHeader, catalogPlugin, CatalogTable, DefaultCatalogPageProps } from '@backstage/plugin-catalog';
import {
  CatalogFilterLayout,
  EntityLifecyclePicker,
  EntityListProvider,
  EntityProcessingStatusPicker,
  EntityOwnerPicker,
  EntityTagPicker,
  EntityTypePicker,
  UserListFilterKind,
  UserListPicker,
  EntityKindPicker,
} from '@backstage/plugin-catalog-react';
import React from 'react';


export const CustomCatalogPage = ({
  columns,
  actions,
  initiallySelectedFilter = 'owned',
  initialKind = 'component',
  tableOptions = {},
  emptyContent,
}: DefaultCatalogPageProps) => {
  const orgName =
  useApi(configApiRef).getOptionalString('organization.name') ?? 'Backstage';

  return (
    <PageWithHeader title={orgName} themeId="home">
      <EntityListProvider>
        <Content>
          <ContentHeader title="Catalog">
            <SupportButton>All your software catalog entities</SupportButton>
          </ContentHeader>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <EntityKindPicker initialFilter={initialKind} allowedKinds={["system", "api", "component", "user", "group", "resource"]} />
              <EntityTypePicker />
              <UserListPicker />
              <EntityTagPicker />
            </CatalogFilterLayout.Filters>
            <CatalogFilterLayout.Content>
              <CatalogTable columns={columns} actions={actions} />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </Content>
      </EntityListProvider>
    </PageWithHeader>
  );
};